module.exports = __webpack_public_path__ + "img/gaillarde.df7cda9a.jpg";